function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-4c3d41da\",\"scoped\":false,\"hasInlineConfig\":true}!sass-loader!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./vuetable_tag_sales.vue")
}
var normalizeComponent = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
var __vue_script__ = require("!!babel-loader?{\"cacheDirectory\":true,\"presets\":[[\"env\",{\"modules\":false,\"targets\":{\"browsers\":[\"> 2%\"],\"uglify\":true}}],\"es2015\"],\"plugins\":[\"transform-object-rest-spread\",[\"transform-runtime\",{\"polyfill\":false,\"helpers\":false}],\"syntax-dynamic-import\",\"transform-vue-jsx\"]}!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./vuetable_tag_sales.vue")
/* template */
var __vue_template__ = require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4c3d41da\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!pug-deps-loader!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./vuetable_tag_sales.vue")
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/franchise_component/item/vuetable_tag_sales.vue
// module id = Yt5A
// module chunks = 99